import Location from 'react-app-location';

export const FindRequestsLocation = new Location('/requests/find');
